const cookieConfig = {
  sameSite: 'lax',
  path: '/',
};
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('referred', (pageName) => {
    const referred = useCookie('referred-from-page', cookieConfig);

    referred.value = pageName;
  });
});
